export enum PoiSecurityZoneItems {
	All = 'All Security Zones',
	BeforeSecurity = 'Before Security',
	AfterSecurity = 'After Security',
}

export const poiSecurityZoneItems = Object.values(PoiSecurityZoneItems);
